// Collapse an affiliate row's ticket breakdown to a single dimension when only
// one of the ticket-type / ticket-option toggles is on. With both on the
// breakdown is returned unchanged; with both off the caller skips it entirely.
// Shared by AffiliateSalesReportTable and the xlsx export so the on-screen and
// exported aggregation always match.
export function aggregateBreakdown(breakdown, showTicketType, showTicketOption) {
    if (showTicketType && showTicketOption) return breakdown;
    const map = new Map();
    for (const bd of breakdown) {
        const key = showTicketType
            ? String(bd.ticketTypeId ?? 'null')
            : String(bd.ticketOptionId ?? 'null');
        if (map.has(key)) {
            const row = map.get(key);
            row.itemCount += bd.itemCount;
            row.totalSales += bd.totalSales;
        } else {
            map.set(key, { ...bd });
        }
    }
    return [...map.values()];
}

export default aggregateBreakdown;
